module.exports = __webpack_public_path__ + "media/images/icon_fb-09cb44ae6e9bccd865c4be9caf6c5768.png";